import React from 'react';
import FieldEventStartEnd from "../start-end";
import formatDate from "../../../../../gd/format/date";
import formatDaterangeShort from "../../../../../gd/format/daterange-short";


type Props = {
    field       : FieldEventStartEnd
    model       : any,
    module      : any   // in this case this is glist !
    onClick?    : onClick
};

export default function FieldEventStartEnd_GlistView(props:Props) {

    if (props.model.isSingleDayType) {
        return (
            <div className="ui5-txt-less-important-small txt-truncate">
                {"{0}".f(formatDate(props.model.startDate))}
            </div>
        )
    } else {
        return (
            <div className="ui5-txt-less-important-small txt-truncate">
                {formatDaterangeShort(props.model.startDate, props.model.endDate)}
                {/*{"{0} - {1}".f(formatDate(props.model.startDate), formatDate(props.model.endDate))}*/}
            </div>
        )
    }

}
